import axios from 'axios';

async function getSteps(companyId) {
  const response = await axios.get(`/companies/${companyId}/register/steps`);

  return response.data;
}

async function updateStep(companyId, step) {
  const response = await axios.put(`/companies/${companyId}/register/steps/${step}`);

  return response.data;
}

const stepService = {
  getSteps,
  updateStep,
}

export default stepService;
